module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Font-0a727b472da905284bee4d4c786fdad8.svg";